import { useEffect } from 'react';

export const useGeofencingHandler = ({ triggerGeolocation, receivePacket, onConnect, onError }) => {
    useEffect(() => {
        window.geofencingHandler = {
            trigger: () => triggerGeolocation(),
            init: () => onConnect(),
            geopacket: (transactionID, geoPacket) => receivePacket(geoPacket, 'geocomply', transactionID),
            error: (transactionID, errorCode, message) => onError(errorCode, message)
        };
    }, [
        triggerGeolocation,
        receivePacket,
        onConnect,
        onError
    ]);
};
